module.exports = __webpack_public_path__ + "static/media/list.73d43c9b.svg";